import React, { useEffect, useMemo, useState } from 'react';

import { Home } from '@mui/icons-material';
import dayjs from 'dayjs';
import { Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { getList, getLOBPushNotifications } from './operations';
import { Button, PushNotificationsHeader, LOBPushNotificationsTable, SubHeader, Footer } from '../../../components';
import pushNotificationsOptions from '../pushNotificationsOptions';

import './styles.scoped.css';

const utc = require('dayjs/plugin/utc');

dayjs.extend(utc);

const LOBPushNotifications = () => {
  const navigate = useNavigate();
  const { statuses } = pushNotificationsOptions;
  const [form, setForm] = useState({});
  const [lobs, setLOBs] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isLoadingLOBs, setIsLoadingLOBs] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const nextToken = null;
  let prevToken = null;

  const formFilters = () => {
    const filters = {};

    if (form) {
      filters.type = { eq: 'LOB' };
      filters.subject = { ne: 'Driver Survey' };
    }

    if (form.lob) {
      filters.lob = { contains: form?.lob };
    }

    if (form?.status !== undefined && form?.status !== '' && form?.status !== null) {
      filters.status = { eq: form?.status };
    }

    if (form?.createdAtStartDate && form?.createdAtEndDate) {
      const startDate = dayjs(form?.createdAtStartDate).startOf('day').toISOString();
      // Set the end date to the end of the day
      const endDate = dayjs(form?.createdAtEndDate).endOf('day').toISOString();
      filters.createdAt = { between: [`${dayjs.utc(startDate).format()}`, `${dayjs.utc(endDate).format()}`] };
    }

    return filters;
  };

  const getFilteredNotifications = async token => {
    const filters = formFilters();
    const newNotifications = await getLOBPushNotifications(filters, token);

    return {
      list: newNotifications?.items,
      tokenResult: newNotifications?.nextToken,
    };
  };

  const getBatch = async (aNextToken = undefined) => {
    if (prevToken !== aNextToken) {
      prevToken = aNextToken;

      const response = await getFilteredNotifications(aNextToken);
      const items = response?.list;
      const token = response?.tokenResult;

      if (token !== null) {
        getBatch(token);
        if (items) {
          setNotifications([items, ...items]);
        }
      } else {
        setIsSearching(false);
      }
    }
  };

  const handleSearch = async () => {
    setIsSearching(true);
    const response = await getFilteredNotifications(nextToken);

    if (Array.isArray(response?.list) && response?.list.length > 0) {
      setNotifications([...response.list]);
      setIsSearching(false);
    } else {
      getBatch(response?.tokenResult);
    }
  };

  const handleGetLOB = async () => {
    setIsLoadingLOBs(true);
    const newLobs = await getList('line-of-business');
    setLOBs(newLobs);
    setIsLoadingLOBs(false);
  };

  const lobsOptions = useMemo(
    () =>
      lobs?.map(({ LineOfBusinessCode, LineOfBusinessDesc }) => ({
        label: LineOfBusinessCode,
        value: LineOfBusinessDesc,
      })),
    [lobs],
  );

  useEffect(() => {
    handleGetLOB();
    handleSearch();
  }, []);

  return (
    <>
      <SubHeader
        text="Push Notifications"
        buttons={[
          { icon: <Home sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/push-notifications') },
        ]}
      />

      <div className="wrap">
        <PushNotificationsHeader
          form={form}
          setForm={setForm}
          lobs={lobsOptions}
          isLoadingLOBs={isLoadingLOBs}
          setIsSearching={setIsSearching}
          setNotifications={setNotifications}
          route="add-lob-push-notification"
          statuses={statuses}
          title="Line of Business Push Notifications"
          handleSearch={handleSearch}
        />

        {Array.isArray(notifications) && !isSearching ? (
          <LOBPushNotificationsTable
            data={notifications}
            editRoute="/push-notifications/lob-push-notifications/edit-lob-push-notification"
          />
        ) : (
          <div className="h-100 d-flex justify-content-center p-5">
            <Spinner animation="border" />
          </div>
        )}

        <Row className="justify-content-center">
          <Button
            variant="outline"
            onPress={() => {
              navigate('/push-notifications');
            }}
            text="Cancel"
          />
        </Row>
      </div>

      <Footer />
    </>
  );
};

export default LOBPushNotifications;
